import script from "./GameBoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameBoardView.vue?vue&type=script&setup=true&lang=js"

import "./GameBoardView.vue?vue&type=style&index=0&id=62475f51&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62475f51"]])

export default __exports__